<template>
  <div class="superparent">
    <div class="parentblockdiv">
      <div class="custom-tree-container">
          <p>Services</p>
          <el-tree
            :data="this.$store.state.ServiceTree"
            show-checkbox
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderContent">
          </el-tree>

      </div>
    </div>

    <div class="parentblockdiv">
      <div class="custom-tree-container">
          <p>Customer Segments</p>
          <el-tree
            :data="this.$store.state.CustomerSegmentsTree"
            show-checkbox
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderContent">
          </el-tree>

      </div>
    </div>
    <div>
      <pythonAPI></pythonAPI>
    </div>



  </div>

</template>
<style>
  .superparent {
    width:600px;

    flex: 10;
    display: flex;
  }
  .parentblockdiv {
    width: 350px;
    flex: 1;
    padding-right: 20px;

  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: left;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

</style>
<script>
// @ is an alias to /src
import pythonAPI from '@/views/pythonAPI.vue'

let id = 1000;

export default {
  name: 'Setup',
  components: {

    pythonAPI

  },
    data() {
    const data = [{
      id: 1,
      label: 'Level one 1',
      children: [{
        id: 4,
        label: 'Level two 1-1',
        children: [{
          id: 9,
          label: 'Level three 1-1-1'
        }, {
          id: 10,
          label: 'Level three 1-1-2'
        }]
      }]
    }, {
      id: 2,
      label: 'Level one 2',
      children: [{
        id: 5,
        label: 'Level two 2-1'
      }, {
        id: 6,
        label: 'Level two 2-2'
      }]
    }, {
      id: 3,
      label: 'Level one 3',
      children: [{
        id: 7,
        label: 'Level two 3-1'
      }, {
        id: 8,
        label: 'Level two 3-2'
      }]
    }];
    return {
      data: JSON.parse(JSON.stringify(data)),
      data: JSON.parse(JSON.stringify(data))
    }
  },

  methods: {
    append(data) {
      const newChild = { id: id++, label: 'testtest', children: [] };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },

    renderContent(h, { node, data, store }) {

      //find if nested/child. disable append button if true

      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>{node.id}</span>
          <span>
            <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
            <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
          </span>
        </span>);
    }
  }

}
</script>
